module.exports = __webpack_public_path__ + "img/s2P6.2a27fe67.png";